<app-grid [data]="data" [isBusy]="!collectionName" [sort]="[{ field: 'id', dir: 'asc' }]">
    <kendo-grid-column [width]="100">
        <ng-template kendoGridCellTemplate let-row>
            <div class="grid-row-toolbar">
                <button class="btn btn-sm btn-success grid-row-action-button" (click)="approveBerthProposal(row.id)" *ngIf="isApproveBerthProposalVisible(row.id)" translate>
                    <fa-icon [icon]="['fas','check']"></fa-icon>
                </button>
                <button class="btn btn-sm btn-danger grid-row-action-button" (click)="rejectBerthProposal(row.id)" *ngIf="isRejectBerthProposalVisible(row.id)" translate>
                    <fa-icon [icon]="['fas','xmark']"></fa-icon>
                </button>
                <!--<button class="btn btn-sm btn-secondary grid-row-action-button" (click)="undoBerthProposal(row.id)" *ngIf="isUndoBerthProposalVisible(row.id)" translate>
                    <fa-icon [icon]="['fas','rotate-left']"></fa-icon>
                </button>-->
            </div>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="berthId" title="{{'Berth' | translate}}" [width]="200">
        <ng-template kendoGridCellTemplate let-row>
            <span>{{row.berthId | codelist:'Berth' | async}} </span>
        </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="createdById" title="{{'Proposed by' | translate}}" [width]="200">
        <ng-template kendoGridCellTemplate let-row>
            <span>{{row.createdById | codelist:'User' | async}} </span>
        </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="accepted" title="{{'Accepted' | translate}}" [width]="200">
        <ng-template kendoGridCellTemplate let-row>
            <span *ngIf="row.accepted!=null && row.accepted" class="text-success">
                ✔
            </span>
            <span *ngIf="row.accepted!=null && !row.accepted" class="text-danger">
                ✖
            </span>
        </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="acceptedDate" title="{{'Accepted Date' | translate}}" [width]="200">
        <ng-template kendoGridCellTemplate let-row>
            <span>{{row.acceptedDate | date:'dd/MM/yyyy HH:mm'}} </span>
        </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="agentNote" title="{{'Agent Note' | translate}}" [width]="200">
        <ng-template kendoGridCellTemplate let-row>
            <span>{{row.agentNote}} </span>
        </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="dispatcherNote" title="{{'Dispatcher Note' | translate}}" [width]="200">
        <ng-template kendoGridCellTemplate let-row>
            <span>{{row.dispatcherNote}} </span>
        </ng-template>
    </kendo-grid-column>
    
    <kendo-grid-column field="lastModifiedById" title="{{'Last Modified By' | translate}}" [width]="200">
        <ng-template kendoGridCellTemplate let-row>
            <span>{{row.lastModifiedById | codelist:'User' | async}} </span>
        </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="lastModifiedDate" title="{{'Last Modified Date' | translate}}" [width]="200">
        <ng-template kendoGridCellTemplate let-row>
            <span>{{ row.lastModifiedDate | date:'dd/MM/yyyy HH:mm' }} </span>
        </ng-template>
    </kendo-grid-column>

    <ng-template kendoGridToolbarTemplate>
        <button *ngIf="editMode && addBerthVisible" class="btn btn-sm btn-primary float-right" (click)="addBerthProposal()" translate>
            <fa-icon icon="paperclip"></fa-icon>
            Add berth
        </button>
    </ng-template>
</app-grid>
